<template>
  <v-layout row wrap>
    <v-flex xs12 v-if="this.isComponent('other-sensors-dash')">
      <Card class="mb-2" v-for="(d, index) in originalData" :key="index">
        <div>
          <v-flex d-flex md12>
            <Toolbar>
              <v-flex sm4>
                <span class="mr-4 body-2">{{ $t(d.name) }} </span>
              </v-flex>
              <v-spacer></v-spacer>
              <v-flex sm4 text-sm-right>
                <v-btn
                  :class="buttonColor"
                  v-show="isShowDetailButtonVisible[d.name]"
                  @click="elaborateHandler(d.name)"
                >
                  {{ $t("SHOW DETAILS") }}
                </v-btn>
              </v-flex>
            </Toolbar>
          </v-flex>
          <v-data-table
            :headers="d.header"
            :items="d.data"
            class="elevation-1 tableLength"
            :pagination.sync="d.pagination"
            hide-actions
          >
            <template v-slot:headers="props">
              <tr>
                <th
                  v-for="header in props.headers"
                  :key="header.text"
                  @click="changeSort(header.value, index)"
                  :class="[
                    'column sortable',
                    d.pagination.descending ? 'desc' : 'asc',
                    header.value === d.pagination.sortBy ? 'active' : '',
                  ]"
                >
                  {{ header.text }}
                  <v-icon small v-show="header.text != ''">arrow_upward</v-icon>
                </th>
              </tr>
            </template>
            <template v-slot:items="props">
              <tr @click="checkboxChangeHandler(props, d.name)">
                <td>
                  <label class="radioBtn--outer">
                    <input
                      :class="`--${simpleString(props.item.name)}`"
                      type="checkbox"
                      :value="checkbox[props.item.name]"
                      @change="checkboxChangeHandler(props, d.name)"
                    />
                    <span class="radioBtn--inner"></span>
                  </label>
                </td>
                <template v-for="header in d.header">
                  <td
                    v-if="header.value != ''"
                    :class="
                      header.value == 'name' || header.value == 'sensor_time'
                        ? 'text-xs-center'
                        : 'number--text text-xs-center'
                    "
                    :style="
                      d.styleCondition &&
                      header.value == 'name' && {
                        color: d.styleCondition(
                          ...d.styleParameter.map((el) => props.item[el])
                        ),
                      }
                    "
                    :key="header.value"
                  >
                    <div>
                      {{
                        props.item[header.value] !== null
                          ? props.item[header.value]
                          : "NA"
                      }}
                    </div>
                  </td>
                </template>
              </tr>
            </template>
          </v-data-table>
        </div>
        <div v-if="isElaborateGraphOrTable[d.name]">
          <v-flex class="pt-2 pr-2 text-xs-center">
            <Toggle
              :modelValue="currentView"
              :theme="theme"
              @toggleValueChange="(val) => (currentView = val)"
            >
              <v-btn flat value="graph">
                <span>{{ $t("Graph") }}</span>
                <v-icon>bar_chart</v-icon>
              </v-btn>
              <v-btn flat value="table">
                <span>{{ $t("Table") }}</span>
                <v-icon>table_chart</v-icon>
              </v-btn>
            </Toggle>
          </v-flex>
          <v-flex v-if="currentView === 'table'">
            <RecyclerDataTable
              v-if="extendedTableData.length"
              :headers="computedHeader"
              :items="extendedTableData"
              :key_field="'sensor_time'"
            />
          </v-flex>

          <v-flex v-if="currentView === 'graph'">
            <GlobalGraph
              class="graph"
              v-if="series.length"
              :series="computedSeries"
              :xAxisData="xAxis"
              :loading="graphLoading"
              :theme="theme"
            />
          </v-flex>
        </div>
      </Card>
    </v-flex>
    <NoDevice v-else :message="subscriptionMessage" />
  </v-layout>
</template>

<script>
import GlobalGraph from "@/components/common/GlobalGraph.vue";
import { mixin, mapGettersMixin } from "@/util/mixin/index";
import OtherSensorApi from "@/services/OtherSensors";
import { mapGetters, mapMutations } from "vuex";
const DataTable = () => import("@/components/other_sensors/TableData.vue");
const NoDevice = () => import("@/components/utility/NoDevice.vue");
const paramMap = require("@/assets/ParamMap.json");

const momentTz = require('moment-timezone');
const moment = require("moment");

export default {
  mixins: [mixin, mapGettersMixin],
  components: {
    DataTable,
    GlobalGraph,
    NoDevice,
    RecyclerDataTable: () =>
      import("@/components/utility/RecyclerDataTable.vue"),
  },
  props: {
    changesFromFilter: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      graphLoading: false,
      currentView: "graph",
      isElaborateGraphOrTable: {},
      isShowDetailButtonVisible: {},
      checkbox: {},
      originalData: [],
      selectedRow: [],
      upsData: null,
      upsHeader: [],
      dcBatteryChargerData: null,
      dcBatteryChargerHeader: [],
      emData: null,
      emHeader: [],
      trasnformerHeader: [],
      transformerData: null,
      soilSensorData: null,
      soilSensorHeader: [],
      transformerHeader: [],
      trackerData: null,
      breakerData: null,
      breakerHeader: [],
      rtuPanelHeader: [],
      rtuPanelData: [],
      trackerHeader: [],
      tableComponentKey: 0,
      extendedTableData: [],
      extendedTableHeader: [],
      series: [],
      xAxis: [],
      filter:[
        {
          id: "Date",
          type: "singleDatePicker",
          title: "Date",
        },
      ],
      activeFilter: {},
    }
  },
  computed: {
    ...mapGetters([
      "getSelectedPlantId",
      "getPlantName",
      "isComponent",
      "getActivePlantTimezone"
    ]),
    date() {
      return this.activeFilter.Date ? this.activeFilter.Date.from : '';
    },
    // TODO: Remove this when the time of refactoring API
    show_date() {
      return moment(this.date).format("YYYY/M/D");
    },
    buttonColor() {
      return this.theme === "dark" ? "activeButton" : "grey lighten-1";
    },
    computedSeries() {
      const cloneSeries = _.cloneDeep(this.series);
      return cloneSeries.map((el) => {
        el.name = this.$t(el.name);
        return el;
      });
    },
    computedHeader() {
      const cloneHeader = _.cloneDeep(this.extendedTableHeader);
      return cloneHeader.map((el) => {
        el.key = this.$t(el.key);
        return el;
      });
    },
  },
  mounted() {
    const Obj = {}
    const cloneFilterOption = _.cloneDeep(this.filter);
    cloneFilterOption.forEach(child => {
      if (child.type === 'singleDatePicker') {
        const parameters = ['from', 'to']
        parameters.forEach(key => {
          if (!Obj[child.id]) { Obj[child.id] = {} }
          Obj[child.id][key] = momentTz().tz(this.getActivePlantTimezone).format('YYYY-MM-DD')
        })
      }
    })
    this.activeFilter = Obj;
    this.$emit("filter:config", cloneFilterOption);
    this.$emit('initial:active_filter', Obj)

    this.checkbox = {};
    this.selectedRow = [];
    this.isElaborateGraphOrTable = {};
    this.isShowDetailButtonVisible = {};
    this.setIntervalWithoutDelay(this.callAllApi);
  },
  methods: {
    ...mapMutations([
      'SET_LAST_CALL_TIME',
      'SET_PROGRESS_BAR'
    ]),
    changeSort(column, index) {
      if (column != "") {
        if (this.originalData[index].pagination.sortBy === column) {
          this.originalData[index].pagination.descending =
            !this.originalData[index].pagination.descending;
        } else {
          this.originalData[index].pagination.sortBy = column;
          this.originalData[index].pagination.descending = false;
        }
      }
    },
    async callAllApi() {
      let updateTime = moment().format("MM-DD-YYYY H:mm:ss");
      this.SET_LAST_CALL_TIME(updateTime);
      const selectedDevice = Object.keys(this.isElaborateGraphOrTable).filter(
        (el) => this.isElaborateGraphOrTable[el]
      );
      this.originalData = [];
      this.extendedTableHeader = [];
      this.extendedTableData = [];
      this.series = [];
      this.xAxis = [];
      await this.getData();

      // If the graph is open
      if (selectedDevice.length > 0) {
        const selectedCheckboxArr = Object.keys(this.checkbox).filter(
          (el) => this.checkbox[el]
        );
        document.querySelector(`.${selectedCheckboxArr[0]}`).checked =
          this.checkbox[selectedCheckboxArr[0]];
        await this.elaborateHandler(selectedDevice[0]);
      }
    },
    createHeader: (device, sampleData) => {
      const resultHeader = [{ text: "", value: "", sortable: false }];
      Object.keys(sampleData).forEach((param) => {
        if (param != "device_id") {
          resultHeader.push({
            text: paramMap[device][param] ? paramMap[device][param] : param,
            value: param,
            sortable: true,
            align: "center",
            class: "primary",
          });
        }
      });
      return resultHeader;
    },
    checkboxChangeHandler(identifier, name) {
      // Show detail functionality
      const checkboxIdentifier = `--${this.simpleString(identifier.item.name)}`;
      this.$set(
        this.isShowDetailButtonVisible,
        name,
        !this.checkbox[checkboxIdentifier]
      );
      this.originalData.forEach((el) => {
        if (el.name !== name) {
          this.$set(this.isShowDetailButtonVisible, el.name, false);
          this.$set(this.isElaborateGraphOrTable, el.name, false);
        }
      });

      // CHECKBOX FUNCTIONALITY
      this.$set(
        this.checkbox,
        checkboxIdentifier,
        !this.checkbox[checkboxIdentifier]
      );
      document.querySelector(`.${checkboxIdentifier}`).checked =
        this.checkbox[checkboxIdentifier];
      if (this.checkbox[checkboxIdentifier]) {
        Object.keys(this.checkbox).forEach((el) => {
          if (el !== checkboxIdentifier && !!this.checkbox[el]) {
            this.$set(this.checkbox, el, false);
            document.querySelector(`.${el}`).checked = false;
          }
        });
      } else {
        // Don't show the graph ass well
        this.$set(this.isElaborateGraphOrTable, name, false);
      }
    },
    async elaborateHandler(selectedDevice) {
      let deviceNameMap = {
        'Energy Meter': 'energy meter',
        'Breaker': 'breaker',
        'Soil Sensor': 'soil sensor',
        'Transformer': 'transformer',
        'Tracker': 'tracker',
        'UPS': 'ups',
        'RTU Panel': 'rtu panel',
        'DC Battery Charger': 'dc battery charger'
      }

      this.$set(this.isElaborateGraphOrTable, selectedDevice, true);
      const distortedString = Object.keys(this.checkbox).filter(
        (el) => this.checkbox[el]
      );
      const selectedObject = this.originalData.filter(
        (el) => el.name === selectedDevice
      )[0];
      const selectedObjectData = selectedObject["data"];
      this.selectedRow = selectedObjectData.filter(
        (el) => `--${this.simpleString(el.name)}` == distortedString
      );

      this.extendedTableData = [];
      this.extendedTableHeader = [];
      this.series = [];
      this.xAxis = [];
      try {
        const param = {
          dateFrom: this.date,
          dateTo: this.date,
          interval: 5,
          query: [],
        };
        const query = {
          plantId: this.getSelectedPlantId,
          name: this.getPlantName(this.getSelectedPlantId),
          query: [],
        };

        const deviceDetails = {};
        deviceDetails["device"] = deviceNameMap[selectedDevice];
        deviceDetails["id"] = this.selectedRow[0].device_id;
        deviceDetails["name"] = this.selectedRow[0].name;
        query["query"].push(deviceDetails);
        param["query"].push(query);

        this.graphLoading = true;
        const response = await OtherSensorApi.getExtendedDeviceData(param);
        // TABLE
        this.extendedTableData = response.data.message.data.map((obj) => {
          const newObj = {};
          for (const [key, value] of Object.entries(obj)) {
            if (key !== "sensor_time") {
              let keyName = key
                .replace(`${this.getPlantName(this.getSelectedPlantId)} `, "")
                .replace(`${this.selectedRow[0].name} `, "");
              newObj[keyName] = value;
            } else {
              newObj[key] = value;
            }
          }
          return newObj;
        });
        this.extendedTableHeader = response.data.message.headers.map((el) => {
          if (el.value !== "sensor_time") {
            el.key = el.paramName;
            el.value = el.paramName;
          }
          return el;
        });
        this.tableComponentKey += 1;
        // GRAPH
        this.graphTransLogic();
        this.graphLoading = false;
      } catch (err) {
        this.graphLoading = false;
      }
    },
    convertNumericToDecimal(objArr, decimalPlaces, excludeArr = []) {
      let arr = [...objArr];
      for (let i = 0; i < arr.length; i++) {
        Object.keys(arr[i]).forEach((key) => {
          if (arr[i][key] === null || excludeArr.includes(key)) {
            return;
          }
          let x = Number(arr[i][key]);
          if (!isNaN(x)) {
            arr[i][key] = x.toFixed(decimalPlaces);
          }
        });
      }
      objArr = arr;
    },
    changeKeyName(oldObj, oldKey, newKey) {
      const keys = Object.keys(oldObj);
      const result = keys.reduce((acc, val) => {
        // Modify key name
        if (oldKey == val) {
          acc[newKey] = oldObj[oldKey];
        } else {
          acc[val] = oldObj[val];
        }
        return acc;
      }, {});
      return result;
    },
    graphTransLogic() {
      const series = [];
      const axis = new Set();

      this.extendedTableHeader.map((el, index) => {
        if (el.value !== "sensor_time") {
          series.push({
            type: "line",
            large: true,
            name: el.paramName,
            data: [],
          });
          this.extendedTableData.forEach((data) => {
            axis.add(data["sensor_time"]);
            Object.keys(data).forEach((dk) => {
              if (dk == el.paramName) {
                series[index - 1].data.push(data[dk]);
              }
            });
          });
        }
      });
      this.series = [...series];
      this.xAxis = Array.from(axis).sort((a, b) => moment(a).diff(b));
    },
    async getData() {
      try {
        this.SET_PROGRESS_BAR(true);
        let response = await OtherSensorApi.getOtherSensorsData(
          this.getSelectedPlantId
        );
        let parameters = response.data.message;
        let parameterList = parameters
          ? parameters.toLowerCase().split(",")
          : [];
        for (var i = 0; i < parameterList.length; i++) {
          switch (parameterList[i]) {
            case 'energy_meter':
              await this.getEmData()
              break
            case 'ups':
              await this.getUpsData()
              break
            case 'soil_sensor':
              await this.getSoilSensorData()
              break
            case 'transformer':
              await this.getTransformerData()
              break
            case 'tracker':
              await this.getTrackerData()
              break
            case 'breaker':
              await this.getBreakerData()
              break
            case 'rtu panel':
              await this.getRtuPanelData()
              break
            case 'dc_battery_charger':
              await this.getDcBatteryChargerData()
              break
          }
        }
        this.SET_PROGRESS_BAR(false);
      } catch (err) {
        this.SET_PROGRESS_BAR(false);
      }
    },
    async getEmData() {
      let response = await OtherSensorApi.getEmData(
        this.getSelectedPlantId,
        this.date
      );
      this.SET_PROGRESS_BAR(false);

      if (response.status === 200) {
        this.emData = response.data.message.map((el) => {
          el = this.changeKeyName(el, "em_name", "name");
          return {
            ...el,
            v1: el.v1 && el.v1 / 1000, // converting values from volts to kilo volts.
            v2: el.v1 && el.v2 / 1000,
            v3: el.v1 && el.v3 / 1000,
          };
        });

        this.convertNumericToDecimal(this.emData, 2);
        this.emHeader = this.createHeader("energy_meter", this.emData[0]);

        this.originalData.push({
          name: "Energy Meter",
          header: [...this.emHeader],
          data: [...this.emData],
          pagination: {
            sortBy: "name",
            descending: false,
            page: 1,
            rowsPerPage: 500,
          }
        })
      }
    },
    async getRtuPanelData() {
      let response = await OtherSensorApi.getRtuPanelData(
        this.getSelectedPlantId,
        this.date
      )
      this.SET_PROGRESS_BAR(false)
      if (response.status === 200) {
        this.rtuPanelData = response.data.message.map(el => {
          el = this.changeKeyName(el, 'rtu_panel_name', 'name')
          return el
        })
        this.rtuPanelHeader = this.createHeader('rtu panel', this.rtuPanelData[0])
        this.originalData.push({
          name: 'RTU Panel',
          header: [...this.rtuPanelHeader],
          data: [...this.rtuPanelData],
          pagination: {
            sortBy: "name",
            descending: false,
            page: 1,
            rowsPerPage: 500,
          }
        })
      }
    },
    async getDcBatteryChargerData() {
      let response = await OtherSensorApi.getDcBatteryChargerData(
        this.getSelectedPlantId,
        this.date
      );
      this.SET_PROGRESS_BAR(false);
      if (response.status === 200) {
        this.dcBatteryChargerData = response.data.message.map(el => {
          el = this.changeKeyName(el, 'dc_battery_charger_name', 'name')
          return el
        })
        this.dcBatteryChargerHeader = this.createHeader('dc battery charger', this.dcBatteryChargerData[0])
        this.originalData.push({
          name: "DC Battery Charger",
          header: [...this.dcBatteryChargerHeader],
          data: [...this.dcBatteryChargerData],
          pagination: {
            sortBy: "name",
            descending: false,
            page: 1,
            rowsPerPage: 500,
          }
        })
      }
    },
    async getUpsData() {
      try {
        let response = await OtherSensorApi.getUpsData(
          this.getSelectedPlantId,
          this.date
        );
        this.SET_PROGRESS_BAR(false);
        this.upsData = response.data.message.map((el) => {
          el = this.changeKeyName(el, "ups_name", "name");
          return el;
        });

        this.convertNumericToDecimal(this.upsData, 2);
        this.upsHeader = this.createHeader("ups", this.upsData[0]);
        this.originalData.push({
          name: "UPS",
          header: [...this.upsHeader],
          data: [...this.upsData],
          pagination: {
            sortBy: "name",
            descending: false,
            page: 1,
            rowsPerPage: 500,
          }
        })
      } catch (err) {
        this.SET_PROGRESS_BAR(false);
      }
    },
    async getSoilSensorData() {
      try {
        let response = await OtherSensorApi.getSoilSensorData(
          this.getSelectedPlantId,
          this.date
        );
        this.SET_PROGRESS_BAR(false);
        this.soilSensorData = response.data.message.map((el) => {
          el = this.changeKeyName(el, "soilsensor_name", "name");
          return el;
        });
        this.convertNumericToDecimal(this.soilSensorData, 2);
        this.soilSensorHeader = this.createHeader(
          "soil_sensor",
          this.soilSensorData[0]
        );
        this.originalData.push({
          name: "Soil Sensor",
          header: [...this.soilSensorHeader],
          data: [...this.soilSensorData],
          pagination: {
            sortBy: "name",
            descending: false,
            page: 1,
            rowsPerPage: 500,
          }
        })
      } catch (err) {
        this.SET_PROGRESS_BAR(false);
      }
    },
    async getTransformerData() {
      let response = await OtherSensorApi.getTransformerData(
        this.getSelectedPlantId,
        this.date
      );
      this.SET_PROGRESS_BAR(false);

      if (response.status === 200) {
        this.transformerData = response.data.message.map((el) => {
          el = this.changeKeyName(el, "transformer_name", "name");
          return el;
        });
        this.convertNumericToDecimal(this.transformerData, 2, ["room_name"]);
        this.transformerHeader = this.createHeader(
          "transformer",
          this.transformerData[0]
        );

        this.originalData.push({
          name: "Transformer",
          header: [...this.transformerHeader],
          data: [...this.transformerData],
          pagination: {
            sortBy: "name",
            descending: false,
            page: 1,
            rowsPerPage: 500,
          }
        })
      }
    },
    async getTrackerData() {
      try {
        let response = await OtherSensorApi.getTrackerData(
          this.getSelectedPlantId,
          this.date
        );
        this.SET_PROGRESS_BAR(false);
        this.trackerData = response.data.message.map((el) => {
          el = this.changeKeyName(el, "tracker_name", "name");
          return el;
        });
        this.convertNumericToDecimal(this.trackerData, 2);
        this.trackerHeader = this.createHeader("tracker", this.trackerData[0]);
        this.originalData.push({
          name: "Tracker",
          header: [...this.trackerHeader],
          data: [...this.trackerData],
          pagination: {
            sortBy: "name",
            descending: false,
            page: 1,
            rowsPerPage: 500,
          }
        })
      } catch (err) {
        this.SET_PROGRESS_BAR(false);
      }
    },
    async getBreakerData() {
      let response = await OtherSensorApi.getBreakerData(
        this.getSelectedPlantId,
        this.date
      );
      this.SET_PROGRESS_BAR(false);
      if (response.status === 200) {
        this.breakerData = response.data.message.map((el) => {
          el = this.changeKeyName(el, "breaker_name", "name");
          return el;
        });
        this.breakerHeader = this.createHeader("breaker", this.breakerData[0]);
        this.originalData.push({
          name: "Breaker",
          header: [...this.breakerHeader],
          data: [...this.breakerData],
          styleParameter: ['breaker_trip', 'breaker_off'],
          styleCondition: (param1, param2) => param1 === 1 || param2 === 1 ? '#f44444' : '#52e652',
          pagination: {
            sortBy: "name",
            descending: false,
            page: 1,
            rowsPerPage: 500,
          }
        })
      }
    },
  },
  watch: {
    changesFromFilter: {
      handler(val) {
        this.activeFilter = val;
      },
      deep: true,
    },
    isReload() {
      if (this.isReload) {
        this.setIntervalWithoutDelay(this.callAllApi);
      }
    },
    getSelectedPlantId() {
      this.isElaborateGraphOrTable = {};
      this.isShowDetailButtonVisible = {};
      this.checkbox = {};
      this.selectedRow = [];
      this.originalData = [];
      this.callAllApi();
    },
    date(newVal, oldVal) {
      if (oldVal != '') {
        this.callAllApi();
      }
    },
  },
};
</script>

<style scoped>
.tableLength {
  max-height: 350px;
  overflow: auto;
}

.div {
  text-align: center;
  margin: 10px;
}

.graph {
  width: 100%;
  height: 400px;
}

/* The checkbox--outer */
.radioBtn--outer {
  display: block;
  position: relative;
  padding-left: 2.188rem;
  margin-bottom: 1.25rem;
  cursor: pointer;
  font-size: 1.375rem;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default radio button */
.radioBtn--outer input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

/* Create a custom radio button */
.radioBtn--inner {
  position: absolute;
  border: 0.125rem solid darkgray;
  top: 0;
  left: 0;
  height: 1.2rem;
  width: 1.2rem;
  border-radius: 50%;
}

/* When the radio button is checked, add a orange background */
.radioBtn--outer input:checked ~ .radioBtn--inner {
  border: 0.138rem solid #f4a135;
}

/* Create the indicator (the dot/circle - hidden when not checked) */
.radioBtn--inner:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the indicator (dot/circle) when checked */
.radioBtn--outer input:checked ~ .radioBtn--inner:after {
  display: block;
}

/* Style the indicator (dot/circle) */
.radioBtn--outer .radioBtn--inner:after {
  top: 0.2rem;
  left: 0.219rem;
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 50%;
  background: #f4a135;
}

.tableLength th {
  z-index: 1 !important;
  position: sticky !important;
  top: 0 !important;
  color: #cbcbcb !important;
  background: var(--v-primary-base) !important;
}
</style>
<style>
.tableLength .v-table__overflow {
  overflow: unset;
}
</style>